import { useQuery } from "react-query"
import { AxiosResponse } from "axios"

import { IGetContentKeywordsRes, IGetContentKeywordsQueryParams } from "types/content"
import languageSettingsService from "api/contentService"

import { LANGS } from "types/shared"

export interface IUseGetAdminKeywordsParams {
  lang: LANGS,
  query: IGetContentKeywordsQueryParams,
  enabled: boolean
}

const useGetAdminKeywords = ({
  lang,
  query,
  enabled
}: IUseGetAdminKeywordsParams) => {
  return useQuery(["admin_keywords", {...query, enabled, lang}], async () => {
    try {
      const res: AxiosResponse<IGetContentKeywordsRes> = await languageSettingsService.getAdminKeywords(lang, query)

      return res.data
    } catch (err: any) {
      return err.response
    }
  }, { enabled, refetchOnMount: false, refetchOnWindowFocus: false })
}

export default useGetAdminKeywords